export default __webpack_public_path__ + "static/media/aqi_band_2.b73da6ba.svg";